<div class="loading-screen" *ngIf="loading">
  <div class="loading-background"></div>
  <div class="lds-css">
    <div style="width: 100%; height: 100%" class="lds-grid">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>

<ng-container *ngIf="session">
  <div style="position: relative">
    <header
      class="hero-unit session-banner"
      id="banner"
      [ngClass]="{ deactivated: session.config.deactivated }">
      <div class="container">
        <div class="row">
          <div class="col-8">
            <div class="box-marked">
              <h1>{{ session.config.title }}</h1>
            </div>
          </div>

          <div class="col-4 d-none d-md-block">
            <div class="header-image">
              <img alt [src]="thumbnailImage" />
            </div>
          </div>
        </div>
      </div>
      <div class="background-image-wrapper">
        <div
          class="background-image"
          [ngStyle]="{
            'background-image': 'url(' + thumbnailImage + ')',
          }"></div>
      </div>
    </header>

    <div
      class="deactivation-notice"
      *ngIf="session.config.deactivated"
      tooltip="{{ session.config.deactivation_message }}"
      placement="bottom">
      Topic is Not Active
      <i class="icon-info"></i>
    </div>
  </div>

  <session-side-nav hidden>
    <session-nav
      [active]="selectedModule === 'details'"
      (selected)="tabSelected('details', true)"
      icon="goal">
      Topic
    </session-nav>

    <session-nav
      *ngIf="session.config.ideas.active"
      [active]="selectedModule === 'ideas'"
      (selected)="tabSelected('ideas', true)"
      icon="ideas">
      Projects
    </session-nav>

    <session-nav
      *ngIf="!session.config.people || session.config.people.active"
      [active]="selectedModule === 'people'"
      (selected)="tabSelected('people', true)"
      icon="people">
      People
    </session-nav>

    <session-nav
      *ngIf="session.config.matrix.active"
      [active]="selectedModule === 'ratings'"
      (selected)="tabSelected('ratings', true)"
      icon="matrix">
      Ratings
    </session-nav>

    <session-nav
      *ngIf="session.config.workspace.active"
      [active]="selectedModule === 'workspace'"
      (selected)="tabSelected('workspace', true)"
      icon="quill">
      Workspace
    </session-nav>

    <session-nav
      *ngIf="session.config.teams_page.active"
      [active]="selectedModule === 'teams'"
      (selected)="tabSelected('teams', true)"
      icon="teams">
      Teams
    </session-nav>

    <session-nav
      *ngIf="session.config.personal_results.active"
      [active]="selectedModule === 'achievements'"
      (selected)="tabSelected('achievements', true)"
      icon="results">
      Personal Results
    </session-nav>

    <session-nav
      *ngIf="!session.config.pdf_exports || session.config.pdf_exports.active"
      (selected)="openReport()"
      icon="file-pdf">
      Session Report
    </session-nav>

    <session-nav
      *ngIf="canMoveProjects"
      (selected)="openMoveIdeasModal()"
      icon="workflow">
      Move Projects
    </session-nav>

    <session-nav
      *ngIf="permissions.session.config.edit(session)"
      [active]="selectedModule === 'settings'"
      (selected)="tabSelected('settings', true)"
      glyph="cog">
      Settings
    </session-nav>

    <session-nav
      *ngIf="permissions.session.config.admin(session)"
      [active]="selectedModule === 'controlcenter'"
      (selected)="tabSelected('controlcenter', true)"
      glyph="cog">
      CC
    </session-nav>

    <!--
  <div ngbDropdown class="submenu-cta-more-dropdown more-dropdown"
    *ngIf="session.config.random_images.active
          || session.config.morphbox.active
          || permissions.session.config.edit(session)">
    <a ngbDropdownToggle id="submenu-dropdown">
      <i class="glyphicon icon-more"></i>
    </a>
    <ul aria-labelledby="submenu-dropdown" ngbDropdownMenu>
      <li *ngIf="session.config.random_images.active">
        <a (click)="tabSelected('randomimages', false)"
            [ngClass]="{'active': selectedModule === 'randomimages'}"><i class="icon-randomimages"></i> Random Images</a>
      </li>
      <li *ngIf="session.config.morphbox.active">
        <a (click)="tabSelected('morphbox', false)"
            [ngClass]="{'active': selectedModule=='morphbox'}"><i class="icon-morphbox"></i> Morphological Box</a>
      </li>
      <li *ngIf="permissions.session.config.edit(session)">
        <a (click)="openMoveIdeasModal()">
          <img alt class="icon" src="assets/icons/workflow.svg"/>Move Ideas
        </a>
      </li>
    </ul>
  </div>
  --></session-side-nav>

  <!-- Subnavigation Start -->

  <div
    class="module-container sub-navigation top-nav d-flex justify-content-between align-items-center">
    <div class="fs-5">{{ session.config.title }}</div>
    <div class="d-flex align-items-center">
      @if (!featureFlags.projectCreation.fastProjectCreation) {
        <a
          class="submenu-cta new-idea-in-topics"
          *ngIf="permissions.session.data.ideas.post(session)"
          (click)="openNewIdeaModal()">
          <i class="icon-newidea"></i>
          <span>New Project</span>
        </a>
      }
      <button
        class="btn btn-lg"
        [title]="session.i_follow ? 'Unfollow' : 'Follow'"
        (click)="session.i_follow ? unfollowSession() : followSession()"
        [ngClass]="
          session.i_follow ? 'icon-star-full' : 'icon-star-empty'
        "></button>

      <button
        class="btn btn-lg fa"
        [title]="session.config.deactivated ? 'Publish' : 'Unpublish'"
        title="Unpublish Project"
        (click)="toggleDeactivated()"
        [ngClass]="
          session.config.deactivated ? 'fa-eye-slash' : 'fa-eye'
        "></button>
    </div>
  </div>

  <!-- Subnavigation End -->

  <!-- Subsubnavigation Start -->

  <!--
<div class="container-fluid sub-sub-navigation" style="opacity: 0" [ngClass]="{ 'active': showSubSubNav }">
  <div class="container">
    <div class="col-lg-10 top-buffer">
      <ul>
        <li *ngIf="session.config.random_images.active">
          <a scroll-sub-menu-on-click (click)="tabSelected('randomimages', false)"
             [ngClass]="{'active': selectedModule=='randomimages'}"><i class="icon-randomimages"></i> Random Images</a>
        </li>

        <li>
          <a scroll-sub-menu-on-click (click)="openReport()">
            <i class="icon-file-pdf"></i> Session Report
          </a>
        </li>
      </ul>
    </div>

  </div>
</div>
-->
  <!-- Subsubnavigation End -->

  <!-- Ideas Start -->

  <div #contentStart></div>

  <div
    class="no-background module-container topic-new-navbar border-bottom pt-2 pb-1">
    <div class="row">
      <div class="col-12 d-flex justify-content-between navbar navbar-expand">
        <ul class="navbar-nav">
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedModule === 'details'"
              (click)="tabSelected('details', true)">
              Topic info
            </button>
          </li>

          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedModule === 'ideas'"
              *ngIf="session.config.ideas.active"
              (click)="tabSelected('ideas', true)">
              Projects
            </button>
          </li>

          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedModule === 'people'"
              *ngIf="!session.config.people || session.config.people.active"
              (click)="tabSelected('people', true)">
              People
            </button>
          </li>

          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedModule === 'ratings'"
              *ngIf="
                session.config.matrix.active &&
                permissions.session.config.edit(session)
              "
              (click)="tabSelected('ratings', true)">
              Ratings
            </button>
          </li>

          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedModule === 'settings'"
              *ngIf="permissions.session.config.edit(session)"
              (click)="tabSelected('settings', true)">
              Settings
            </button>
          </li>

          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="selectedModule === 'controlcenter'"
              *ngIf="permissions.session.config.admin(session)"
              (click)="tabSelected('controlcenter', true)">
              Control center
            </button>
          </li>
        </ul>

        <div class="d-flex gap-2 align-items-center">
          <button
            class="btn btn-primary"
            *ngIf="canMoveProjects"
            (click)="openMoveIdeasModal()">
            Move Projects
            <i class="icon-workflow"></i>
          </button>

          <button
            class="btn btn-primary"
            *ngIf="
              featureFlags.reportGeneration &&
              (true ||
                !session.config.pdf_exports ||
                session.config.pdf_exports.active)
            "
            (click)="openReport()">
            Download
            <i class="fa fa-download"></i>
          </button>

          <groupchat-button
            [session]="session"
            [autoOpen]="true"
            label="Discuss {{
              session.config.cluster ? 'Topic Cluster' : 'Topic'
            }}"></groupchat-button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="container no-background module-container"
    *ngIf="selectedModule === 'ideas'">
    <div class="organiser-info row">
      <div class="col-8">
        <ng-container
          *ngIf="session.config.organizer && session.config.organizer.enabled">
          <img
            alt
            class="organiser-logo"
            [src]="session.config.organizer.logo_id | assets" />
          <span>Session organised by {{ session.config.organizer.name }}.</span>
        </ng-container>
        <ng-container
          *ngIf="
            !session.config.organizer || !session.config.organizer.enabled
          ">
          <br />
          <br />
        </ng-container>
      </div>
    </div>
    <!-- Searchbar(left) Filter (right) for Ideas Start-->
    <div class="row">
      <div class="col-lg-4">
        <input
          type="text"
          width="100"
          class="form-control session-ideas-search"
          [(ngModel)]="searchFilter"
          placeholder="Search for..." />
      </div>
      <div class="col-lg-8 d-flex justify-content-end">
        <div class="idea-filter-group pull-right">
          <span>Filter Projects by</span>
          <div class="btn-group filter-dropdown" ngbDropdown>
            <div
              id="btn-append-to-single-button"
              class="filter-button"
              ngbDropdownToggle>
              {{ selectedFilter }}
              <span class="caret"></span>
            </div>
            <ul class="dropdown-menu filter-list shadow" ngbDropdownMenu>
              <li role="menuitem">
                <button
                  class="dropdown-item"
                  (click)="
                    selectedFilter = 'All Projects';
                    searchFilter = '';
                    ideaFilter.filterFav = false;
                    ideaFilter.filterOwn = false;
                    ideaFilter.filterTeam = false;
                    ideaFilter.filterToRate = false
                  ">
                  All Projects
                </button>
              </li>
              <li role="menuitem">
                <button
                  class="dropdown-item"
                  (click)="
                    selectedFilter = 'Followed Projects';
                    searchFilter = '';
                    ideaFilter.filterFav = true;
                    ideaFilter.filterOwn = false;
                    ideaFilter.filterTeam = false;
                    ideaFilter.filterToRate = false
                  ">
                  Followed Projects
                </button>
              </li>
              <li role="menuitem">
                <button
                  class="dropdown-item"
                  (click)="
                    selectedFilter = 'For me to rate';
                    ideaFilter.filterFav = false;
                    searchFilter = '';
                    ideaFilter.filterOwn = false;
                    ideaFilter.filterTeam = false;
                    ideaFilter.filterToRate = true
                  ">
                  For me to rate
                </button>
              </li>
              <li role="menuitem">
                <button
                  class="dropdown-item"
                  (click)="
                    selectedFilter = 'Mine';
                    ideaFilter.filterFav = false;
                    searchFilter = '';
                    ideaFilter.filterOwn = true;
                    ideaFilter.filterTeam = false;
                    ideaFilter.filterToRate = false
                  ">
                  Mine
                </button>
              </li>
              <!--
            <li role="menuitem"><a (click)="selectedFilter = 'My team (' + teamDict[session.me.team].name + ')'; ideaFilter.filterFav = false; searchFilter = ''; ideaFilter.filterOwn = false; ideaFilter.filterTeam = true; ideaFilter.filterToRate = false; ideaFilter.currentSelectedTeam = ideaFilter.currentUserTeam;">
              My team ({{ teamDict[session.me.team].name }})
            </a></li>
            <li role="menuitem"><a *ngFor="let team of session.config.teams" (click)="selectedFilter = team.name; searchFilter = ''; ideaFilter.filterFav = false; ideaFilter.filterOwn = false;  ideaFilter.filterTeam = true; ideaFilter.filterToRate = false; ideaFilter.currentSelectedTeam = team._id;">{{ team.name }}</a></li>
            --></ul>
          </div>
          <div class="layout-selector">
            <i
              class="icon-view-expanded"
              (click)="setLayout('cards')"
              [ngClass]="{ active: layout === 'cards' }"></i>
            <span>|</span>
            <i
              class="icon-view-bars"
              (click)="setLayout('bars')"
              [ngClass]="{ active: layout === 'bars' }"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- Searchbar(left) Filter (right) for Ideas End-->
    <!--
  <div class="pagination-wrapper">
    <ul uib-pagination total-items="session.data.ideas.length" ng-model="currentPage" items-per-page="maxIdeas"
        class="pagination-sm " boundary-link-numbers="true"></ul>
  </div>
  -->
    <br />
    <!-- Ideas Cards Repeat Start -->
    <div
      class="d-flex ideas-row flex-wrap gap-3"
      [ngClass]="{
        'flex-wrap': layout === 'cards',
        'flex-column': layout === 'bars',
      }">
      <div class="col-lg-12" *ngIf="!session.data.ideas.length">
        <p>No projects added, yet.</p>
      </div>
      <ng-container *ngIf="layout === 'bars'">
        <app-idea-bar-controls
          [sorting]="sorting"
          (sortingChanged)="sorting = $event"></app-idea-bar-controls>
        <app-idea-bar
          *ngFor="let idea of filteredSortedPaginatedIdeas"
          (ideaAction)="openIdea(idea)"
          [idea]="idea"
          [session]="session"></app-idea-bar>
      </ng-container>
      <ng-container *ngIf="layout === 'cards'">
        <app-idea-card
          *ngFor="let idea of filteredSortedPaginatedIdeas"
          (ideaAction)="openIdea(idea)"
          [idea]="idea"
          [session]="session"></app-idea-card>
      </ng-container>
    </div>
    <!-- Ideas Cards Repeat end -->
    <div class="pagination-wrapper mt-5">
      <ngb-pagination
        class="pagination-sm d-flex justify-content-center"
        ali
        [collectionSize]="filteredIdeas.length"
        [(page)]="currentPage"
        [pageSize]="pageSize"
        [boundaryLinks]="true"></ngb-pagination>
    </div>
  </div>
  <!-- Ideas End -->

  <!-- Matrix Start -->
  <!-- This needs to use ng-if, otherwise the idea-matrix labels don't position themselves correctly (getBBox returns 0) -->
  <div
    *ngIf="selectedModule === 'ratings'"
    class="container no-background ideation-module-container module-container">
    <br />
    <br />
    <div class="organiser-info row">
      <div
        class="col-8"
        *ngIf="session.config.organizer && session.config.organizer.enabled">
        <img
          alt
          class="organiser-logo"
          [src]="session.config.organizer.logo_id | assets" />
        Session organised by {{ session.config.organizer.name }}.
      </div>
    </div>
    <div class="row">
      <div class="col-9 ideation-module-container">
        <app-ideas-matrix
          [session]="session"
          (setNodesData)="setNodesData($event)"
          (ideaSelected)="selectIdea($event)"></app-ideas-matrix>
      </div>
      <div class="col-3 still-to-rate-wrapper">
        <div class="still-to-rate">
          <b>Still to rate</b>
          <ul class="still-to-rate-list">
            <ng-container *ngFor="let idea of session.data.ideas">
              <li
                *ngIf="
                  idea.voting.x === 0 &&
                  idea.voting.y === 0 &&
                  idea.published &&
                  permissions.session.data.ideas.vote(session, idea)
                ">
                <span
                  *ngIf="nodesData.length"
                  [ngStyle]="{
                    'background-color': nodesData[idea.created_by][0].color,
                  }"></span>
                <a (click)="openIdea(idea)">{{ idea.title }}</a>
              </li>
            </ng-container>
          </ul>
        </div>
        <div
          *ngIf="selectedIdea"
          class="idea-wrapper pt-3"
          [ngClass]="{ unpublished: !selectedIdea.published }">
          <div (click)="openIdea(selectedIdea)" class="idea">
            <img alt class="idea-image" [src]="selectedIdeaThumbnail" />
            <h4 class="text-marked unpublished" *ngIf="!selectedIdea.published">
              Unpublished (
              <a (click)="publish($event, selectedIdea)">publish</a>
              )
            </h4>
            <br />

            <div
              class="ribbon"
              *ngIf="session.me._id === selectedIdea.created_by">
              <span>Own project</span>
            </div>
          </div>
          <div class="idea-description">
            <h3 class="" (click)="openIdea(selectedIdea)">
              {{ selectedIdea.title || 'No project selected' }}
            </h3>

            <p class="oneliner">
              {{ selectedIdea.one_liner || 'Select an project on the matrix' }}
            </p>
            <div class="idea-footer">
              <p class="contributors">
                <img
                  alt
                  src="assets/images/userpic.png"
                  width="30"
                  height="30"
                  alt="Contributors" />
                1
              </p>
              <p class="followers">
                <span
                  (click)="
                    selectedIdea.i_follow
                      ? unfollow(selectedIdea)
                      : follow(selectedIdea)
                  "
                  [ngClass]="
                    selectedIdea.i_follow ? 'icon-star-full' : 'icon-star-empty'
                  "></span>
                {{ selectedIdea.followers.length }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Matrix End -->

  <!-- Random Words Start -->
  <div class="module-container" *ngIf="selectedModule === 'people'">
    <app-people-module
      [session]="session"
      (openIdea)="openIdea($event)"></app-people-module>
  </div>

  <!-- Morphboxes Start -->
  <div
    *ngIf="selectedModule === 'morphbox'"
    class="container ideation-module-container module-container">
    <div class="col-lg-12">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabIndex" class="nav-tabs">
        <li
          [ngbNavItem]="'tab-' + i"
          *ngFor="let morphbox of session.data.morphboxes; let i = index">
          <button ngbNavLink>{{ morphbox.name }}</button>
          <ng-template ngbNavContent>
            <app-morph-box
              [session]="session"
              [morphbox]="morphbox"></app-morph-box>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
  <!-- Morphbox End -->

  <!-- Random Images Start -->
  <div
    *ngIf="selectedModule === 'randomimages'"
    class="container ideation-module-container module-container">
    <div class="col-lg-12">
      <app-random-images></app-random-images>
    </div>
  </div>
  <!-- Random Images End -->

  <!-- Random Words Start -->
  <div
    *ngIf="selectedModule === 'randomwords'"
    class="container ideation-module-container module-container">
    <div class="col-lg-12">
      <app-random-words></app-random-words>
    </div>
  </div>
  <!-- Random Words End -->

  <!-- Idea Board Start -->
  <div
    class="container ideation-module-container module-container"
    *ngIf="selectedModule === 'workspace'">
    <div class="col-lg-12">
      <app-my-idea-board [session]="session"></app-my-idea-board>
    </div>
  </div>
  <!-- Idea Board End -->

  <!-- Achievements Start -->
  <div
    class="container ideation-module-container module-container"
    *ngIf="selectedModule === 'achievements'">
    <div class="container-fluid">
      <app-personal-results [session]="session"></app-personal-results>
    </div>
  </div>
  <!-- Achievements End -->

  <!-- Teams Start -->
  <div
    class="container ideation-module-container teams-container module-container"
    *ngIf="selectedModule === 'teams'">
    <div class="container-fluid">
      <app-team-page [session]="session" [teamsDict]="teamDict"></app-team-page>
    </div>
  </div>
  <!-- Teams End -->

  <!-- Settings Start -->
  <ng-container *ngIf="selectedModule === 'settings'">
    <div class="container-fluid module-container">
      <app-session-settings [session]="session"></app-session-settings>
    </div>
  </ng-container>
  <!-- Settings End-->

  <!-- CC Start -->
  <ng-container *ngIf="selectedModule === 'controlcenter'">
    <div class="container-fluid module-container">
      <app-control-center [session]="session"></app-control-center>
    </div>
  </ng-container>
  <!-- CC Endfee-->

  <div class="module-container" *ngIf="selectedModule === 'details'">
    <app-session-details [session]="session"></app-session-details>
  </div>
</ng-container>
